const classCode = state => state.joiningOptions.classCode;

const invitationToken = state => state.joiningOptions.invitationToken;

const getStudentClasses = state => state.studentClasses;

const getOpenAssignments = state => state.openAssignments;

const getAllOpenAssignments = state => state.allOpenAssignments;

const needSales = state => state.joiningOptions.needSales;

export default {
    classCode,
    invitationToken,
    getStudentClasses,
    getOpenAssignments,
    getAllOpenAssignments,
    needSales,
};
